// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"765":"a85ff90f261d69e6","888":"bcbac680e6671a10"}[chunkId] + ".css";
};